import { useClientStateSetter, useUserRealmId } from "@easybiz/component-shared";
import { useOrderDoc } from "@easybiz/web-firebase";
import { LazyImage } from "@easybiz/component-web-business-ui";
import { Space } from "antd";
import dayjs from "dayjs";
import { useMemo } from "react";
import LabelButton from "../LabelButton";
import LabelStatusTag from "../LabelStatusTag";
import { formatMediaUrl } from "@easybiz/lib-shared-utils";

export default function ({
  extra,
  orderId,
  order,
  itemIndex,
  limit,
  showStatusTag,
  size,
  width,
  orderOnly,
  wrap,
  onSelectChange,
  selects,
  disabled,
}) {
  const realmId = useUserRealmId();
  const orderDoc = useOrderDoc(!order && orderId);
  const setState = useClientStateSetter();

  const displayPhotos = useMemo(() => {
    return (order?.get("photos") || orderDoc?.get("photos") || [])
      .filter((photo) => (orderOnly ? !photo.l : typeof itemIndex !== "number" || itemIndex === photo.l))
      .map((photo) => {
        return {
          id: photo.i,
          url: formatMediaUrl(photo.i, realmId),
          thumbUrl: formatMediaUrl(photo.i, realmId, true),
          title: `${dayjs.unix(photo.t).format("DD/MM/YYYY HH:mm")} | ${photo.o}`,
          timestamp: photo.t,
        };
      });
  }, [order, orderDoc, realmId, orderOnly, itemIndex]);

  if (extra || displayPhotos.length > 0 || onSelectChange) {
    return (
      <Space direction="horizontal" align="center" style={{ width: width || "100%", overflowX: "auto" }} wrap={wrap}>
        {extra}
        {typeof itemIndex === "number" && onSelectChange && (
          <LabelButton sortIndex={itemIndex} selects={selects} onChange={onSelectChange} disabled={disabled} />
        )}
        {showStatusTag && <LabelStatusTag order={order} sortIndex={itemIndex} />}
        {displayPhotos.map((photo, index) => {
          if (typeof limit === "number" && index >= limit) return null;

          return (
            <div key={`${index}`} style={{ width: size || 70, height: size || 70, objectFit: "contain" }}>
              <div
                className="selectable"
                onClick={(e) => {
                  e.stopPropagation();
                  setState({
                    gallery: { photos: displayPhotos, viewIndex: index, orderId: orderId || order?.id, itemIndex },
                  });
                }}
              >
                <LazyImage src={photo.thumbUrl || photo.url} width={size || 70} height={size || 70} />
              </div>
            </div>
          );
        })}
      </Space>
    );
  } else {
    return null;
  }
}
